import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

/** Fallback text for when zero search results are returned */
const ZeroSearchResultsMsg = (): ReactElement => {
    const theme = useTheme()
    return (
        <Typography variant="h6" component="div">
            There are{" "}
            <Box color={theme.palette.primary.main} display="inline">
                zero devices
            </Box>{" "}
            that match your search criteria
        </Typography>
    )
}

export default ZeroSearchResultsMsg
